import React from 'react';
import { FormField } from '../../../types/formBuilder';

interface RangeInputProps {
  field: FormField;
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
}

export const RangeInput: React.FC<RangeInputProps> = ({
  field,
  value,
  onChange,
  disabled = false
}) => {
  const currentValue = value || field.defaultValue || 50;

  return (
    <div className="space-y-3">
      <input
        type="range"
        value={currentValue}
        onChange={(e) => onChange(parseFloat(e.target.value))}
        min={field.min || 0}
        max={field.max || 100}
        step={field.step || 1}
        disabled={disabled}
        className="w-full h-2 bg-elevated rounded-lg appearance-none cursor-pointer accent-brand"
      />
      <div className="flex justify-between text-sm text-th-secondary">
        <span>{field.min || 0}</span>
        <span className="text-brand font-medium">{currentValue}</span>
        <span>{field.max || 100}</span>
      </div>
    </div>
  );
};